import { Fragment } from 'react';
import styles from '../kyc-intelligence.module.css';

function PANDetails({details}) {

    return (<>
        <div className={styles['basic-report-box']}>
            <h2>PAN details</h2>
            {details.map((panDetails, index) => {
                const data = panDetails?.data?.panDetails;
                // Dynamically filter address keys with non-empty values
                const address = data?.address || {};
                const addressString = Object.entries(address)
                    .filter(([_, value]) => value !== undefined && value !== null && value !== "")
                    .map(([key, value]) => value)
                    .join(', ');
                const dinInfo = panDetails?.data?.dinInfo;
                const gstinDetail = panDetails?.data?.gstinDetail?.info;
                const turnoverKeys = Object.keys(gstinDetail[0]?.turnoverData || {});

                return (
                    <Fragment key={index}>
                        <h3>PAN number - {panDetails?.panNumber}</h3>
                        <h4>PAN details</h4>
                        <div className={styles['basic-report-details']}>
                            <div>
                                <span>PAN number: </span>
                                {data?.pan_number || '-'}
                            </div>
                            <div>
                                <span>Full name: </span>
                                {data?.full_name || '-'}
                            </div>
                            <div>
                                <span>Masked aadhaar: </span>
                                {data?.masked_aadhaar || '-'}
                            </div>
                            <div>
                                <span>Email: </span>
                                {data?.email || '-'}
                            </div>
                            <div>
                                <span>Phone number: </span>
                                {data?.phone_number || '-'}
                            </div>
                            <div>
                                <span>Gender: </span>
                                {data?.gender || '-'}
                            </div>
                            <div>
                                <span>DOB: </span>
                                {data?.dob || '-'}
                            </div>
                            <div>
                                <span>Aadhaar linked: </span>
                                {data?.aadhaar_linked ? 'Yes' : 'No'}
                            </div>
                            <div>
                                <span>Category: </span>
                                {data?.category || '-'}
                            </div>
                            <div>
                                <span>Father name: </span>
                                {data?.fatherName || '-'}
                            </div>
                            <div>
                                <span>Address: </span>
                                {addressString || '-'}
                            </div>
                        </div>
                        <h4>DIN details</h4>
                        <div className={styles['basic-report-details']}>
                            <div>
                                <span>DIN number: </span>
                                {dinInfo?.din || '-'}
                            </div>
                            <div>
                                <span>Found: </span>
                                {dinInfo?.found || '-'}
                            </div>
                        </div>
                        {dinInfo?.director_details?.map((directorDetails, index) => {
                            return (
                                <div key={index}>
                                    <h5>Result {index + 1}</h5>
                                    <div className={styles['basic-report-details']}>
                                        <div>
                                            <span>Name: </span>
                                            {directorDetails?.name || '-'}
                                        </div>
                                        <div>
                                            <span>Mobile: </span>
                                            {directorDetails?.mobile || '-'}
                                        </div>
                                        <div>
                                            <span>Credit score: </span>
                                            {directorDetails?.creditScoreDetail?.result?.credit_score || '-'}
                                        </div>
                                    </div>
                                    {directorDetails?.dinDetails?.map((dinDetails, index) => {
                                        return (
                                            <div key={index} style={{ marginLeft: '50px' }}>
                                                <h6>Result {index + 1}</h6>
                                                <div className={styles['basic-report-details']}>
                                                    <div>
                                                        <span>DIN: </span>
                                                        {dinDetails?.DIN || '-'}
                                                    </div>
                                                    <div>
                                                        <span>CIN: </span>
                                                        {dinDetails?.CIN || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Date join: </span>
                                                        {dinDetails?.DATE_JOIN || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Date regsign: </span>
                                                        {dinDetails?.DATE_RESIGN || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Designation: </span>
                                                        {dinDetails?.DESIGNATION || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Address: </span>
                                                        {dinDetails?.ADDRESS || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Monetary Contribution Value: </span>
                                                        {dinDetails?.monetaryContributionValue || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Contribution Form: </span>
                                                        {dinDetails?.contributionForm || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Body Corporate Type: </span>
                                                        {dinDetails?.bodyCorporateType || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Profit Sharing Percentage: </span>
                                                        {dinDetails?.profitSharingPercentage || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Body Corp Inside India Name: </span>
                                                        {dinDetails?.bodyCorpInsideIndiaName || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Body Corp Outside India Name: </span>
                                                        {dinDetails?.bodyCorpOutsideIndiaName || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Approver CIN: </span>
                                                        {dinDetails?.APPROVER_CIN || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Company name: </span>
                                                        {dinDetails?.COMPANY_NAME || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Company status: </span>
                                                        {dinDetails?.COMPANY_STATUS || '-'}
                                                    </div>
                                                    <div>
                                                        <span>Paidup Capital: </span>
                                                        {dinDetails?.PAIDUP_CAPITAL || '-'}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        })}
                        <h4>GSTIN details</h4>
                        {
                            gstinDetail.length===0
                            ?<>
                                <div className={styles['basic-report-details']}>
                                    <div> No details found </div>
                                </div>
                            </>
                            :<>
                                {gstinDetail?.map((item, index) => {
                                    const singleDetail = item?.details?.result?.result;
                                    const gstinDetailed = singleDetail?.gstnDetailed;

                                    return (
                                        <div key={index}>
                                            <h5>{item.gst}</h5>
                                            <div className={styles['basic-report-details']}>
                                                <div>
                                                    <span>Turn over range (minimum): </span>
                                                    {singleDetail?.aggregateTurnOverRange?.minimum || 0}
                                                </div>
                                                <div>
                                                    <span>Turn over range (maximum): </span>
                                                    {singleDetail?.aggregateTurnOverRange?.maximum || 0}
                                                </div>
                                                <div>
                                                    <span>Annual aggregate turn over: </span>
                                                    {singleDetail?.annualAggregateTurnOver || '-'}
                                                </div>
                                                <div>
                                                    <span>Gross total income: </span>
                                                    {singleDetail?.grossTotalIncome || '-'}
                                                </div>
                                                <div>
                                                    <span>Gross total income financial year: </span>
                                                    {singleDetail?.grossTotalIncomeFinancialYear || '-'}
                                                </div>
                                                <div>
                                                    <span>Constitution of business</span>
                                                    {gstinDetailed.constitutionOfBusiness || '-'}
                                                </div>
                                                <div>
                                                    <span>Legal name of business</span>
                                                    {gstinDetailed.legalNameOfBusiness || '-'}
                                                </div>
                                                <div>
                                                    <span>Trade name of business</span>
                                                    {gstinDetailed.tradeNameOfBusiness || '-'}
                                                </div>
                                                <div>
                                                    <span>Centre jurisdiction</span>
                                                    {gstinDetailed.centreJurisdiction || '-'}
                                                </div>
                                                <div>
                                                    <span>State jurisdiction</span>
                                                    {gstinDetailed.stateJurisdiction || '-'}
                                                </div>
                                                <div>
                                                    <span>Registration date</span>
                                                    {gstinDetailed.registrationDate || '-'}
                                                </div>
                                                <div>
                                                    <span>Tax payer date</span>
                                                    {gstinDetailed.taxPayerDate || '-'}
                                                </div>
                                                <div>
                                                    <span>Tax payer type</span>
                                                    {gstinDetailed.taxPayerType || '-'}
                                                </div>
                                                <div>
                                                    <span>GSTIN status</span>
                                                    {gstinDetailed.gstinStatus || '-'}
                                                </div>
                                                <div>
                                                    <span>Cancellation date</span>
                                                    {gstinDetailed.cancellationDate || '-'}
                                                </div>
                                                <div>
                                                    <span>Nature of business activities</span>
                                                    {gstinDetailed.natureOfBusinessActivities || '-'}
                                                </div>
                                                <div>
                                                    <span>Principal place latitude</span>
                                                    {gstinDetailed.principalPlaceLatitude || '-'}
                                                </div>
                                                <div>
                                                    <span>Principal place longitude</span>
                                                    {gstinDetailed.principalPlaceLongitude || '-'}
                                                </div>
                                                <div>
                                                    <span>Principal place street</span>
                                                    {gstinDetailed.principalPlaceStreet || '-'}
                                                </div>
                                                <div>
                                                    <span>Principal place locality</span>
                                                    {gstinDetailed.principalPlaceLocality || '-'}
                                                </div>
                                                <div>
                                                    <span>Principal place city</span>
                                                    {gstinDetailed.principalPlaceCity || '-'}
                                                </div>
                                                <div>
                                                    <span>Principal place district</span>
                                                    {gstinDetailed.principalPlaceDistrict || '-'}
                                                </div>
                                                <div>
                                                    <span>Principal place state</span>
                                                    {gstinDetailed.principalPlaceState || '-'}
                                                </div>
                                                <div>
                                                    <span>Principal place pincode</span>
                                                    {gstinDetailed.principalPlacePincode || '-'}
                                                </div>
                                                <div>
                                                    <span>Additional place latitude</span>
                                                    {gstinDetailed.additionalPlaceLatitude || '-'}
                                                </div>
                                                <div>
                                                    <span>Additional place longitude</span>
                                                    {gstinDetailed.additionalPlaceLongitude || '-'}
                                                </div>
                                                <div>
                                                    <span>Additional place street</span>
                                                    {gstinDetailed.additionalPlaceStreet || '-'}
                                                </div>
                                                <div>
                                                    <span>Additional place locality</span>
                                                    {gstinDetailed.additionalPlaceLocality || '-'}
                                                </div>
                                                <div>
                                                    <span>Additional place city</span>
                                                    {gstinDetailed.additionalPlaceCity || '-'}
                                                </div>
                                                <div>
                                                    <span>Additional place district</span>
                                                    {gstinDetailed.additionalPlaceDistrict || '-'}
                                                </div>
                                                <div>
                                                    <span>Additional place state</span>
                                                    {gstinDetailed.additionalPlaceState || '-'}
                                                </div>
                                                <div>
                                                    <span>Additional place pincode</span>
                                                    {gstinDetailed.additionalPlacePincode || '-'}
                                                </div>
                                                <div>
                                                    <span>Compliance rating</span>
                                                    {gstinDetailed.complianceRating || '-'}
                                                </div>
                                                <div>
                                                    <span>Director names</span>
                                                    {gstinDetailed.directorNames || '-'}
                                                </div>
                                            </div>
                                            {gstinDetailed?.principalPlaceAddress && <>
                                                <h6>Principal place address</h6>
                                                <div className={styles['basic-report-details']}>
                                                    <div><span>Email:</span> {gstinDetailed.principalPlaceAddress.emailId || '-'}</div>
                                                    <div><span>Address:</span> {gstinDetailed.principalPlaceAddress.address || '-'}</div>
                                                    <div><span>Nature of Business:</span> {gstinDetailed.principalPlaceAddress.natureOfBusiness || '-'}</div>
                                                    <div><span>Mobile:</span> {gstinDetailed.principalPlaceAddress.mobile || '-'}</div>
                                                    <div><span>Last Updated:</span> {gstinDetailed.principalPlaceAddress.lastUpdatedDate || '-'}</div>
                                                    <div>
                                                        <span>Address:</span>
                                                        <ul>
                                                            <li>District: {Array.isArray(gstinDetailed.principalPlaceAddress.splitAddress?.district) && gstinDetailed.principalPlaceAddress.splitAddress.district.length > 0 ? gstinDetailed.principalPlaceAddress.splitAddress.district.join(', ') : '-'}</li>
                                                            <li>State: {Array.isArray(gstinDetailed.principalPlaceAddress.splitAddress?.state) && gstinDetailed.principalPlaceAddress.splitAddress.state.length > 0 ? gstinDetailed.principalPlaceAddress.splitAddress.state.map(arr => Array.isArray(arr) ? arr.join(' / ') : arr).join(', ') : '-'}</li>
                                                            <li>City: {Array.isArray(gstinDetailed.principalPlaceAddress.splitAddress?.city) && gstinDetailed.principalPlaceAddress.splitAddress.city.length > 0 ? gstinDetailed.principalPlaceAddress.splitAddress.city.join(', ') : '-'}</li>
                                                            <li>Pincode: {gstinDetailed.principalPlaceAddress.splitAddress?.pincode || '-'}</li>
                                                            <li>Country: {Array.isArray(gstinDetailed.principalPlaceAddress.splitAddress?.country) && gstinDetailed.principalPlaceAddress.splitAddress.country.length > 0 ? gstinDetailed.principalPlaceAddress.splitAddress.country.join(', ') : '-'}</li>
                                                            <li>Address Line: {gstinDetailed.principalPlaceAddress.splitAddress?.addressLine || '-'}</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </>}
                                            {Array.isArray(gstinDetailed?.additionalPlaceAddress) && gstinDetailed.additionalPlaceAddress.length > 0 && <>
                                                <h6>Additional Place Address</h6>
                                                <div style={{ paddingLeft: '50px' }}>
                                                    {gstinDetailed.additionalPlaceAddress.map((item, idx) => (<Fragment key={idx}>
                                                        <h6>Result {idx+1}</h6>
                                                        <div className={styles['basic-report-details']} key={idx}>
                                                            <div><span>Email:</span> {item.emailId || '-'}</div>
                                                            <div><span>Address:</span> {item.address || '-'}</div>
                                                            <div><span>Nature of Business:</span> {item.natureOfBusiness || '-'}</div>
                                                            <div><span>Mobile:</span> {item.mobile || '-'}</div>
                                                            <div><span>Last Updated:</span> {item.lastUpdatedDate || '-'}</div>
                                                            <div>
                                                            <span>Address:</span>
                                                            <ul>
                                                                <li>District: {Array.isArray(item.splitAddress?.district) && item.splitAddress.district.length > 0 ? item.splitAddress.district.join(', ') : '-'}</li>
                                                                <li>State: {Array.isArray(item.splitAddress?.state) && item.splitAddress.state.length > 0 ? item.splitAddress.state.map(arr => Array.isArray(arr) ? arr.join(' / ') : arr).join(', ') : '-'}</li>
                                                                <li>City: {Array.isArray(item.splitAddress?.city) && item.splitAddress.city.length > 0 ? item.splitAddress.city.join(', ') : '-'}</li>
                                                                <li>Pincode: {item.splitAddress?.pincode || '-'}</li>
                                                                <li>Country: {Array.isArray(item.splitAddress?.country) && item.splitAddress.country.length > 0 ? item.splitAddress.country.join(', ') : '-'}</li>
                                                                <li>Address Line: {item.splitAddress?.addressLine || '-'}</li>
                                                            </ul>
                                                            </div>
                                                        </div>
                                                    </Fragment>))}
                                                </div>
                                            </>}
                                            {singleDetail?.gstnRecords.length!==0 && <>
                                                <h6>GSTIN records</h6>
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Registration name</th>
                                                            <th>GSTIN</th>
                                                            <th>Application status</th>
                                                            <th>Mob num</th>
                                                            <th>Reg type</th>
                                                            <th>Email id</th>
                                                            <th>TIN number</th>
                                                            <th>GSTIN ref id</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {singleDetail?.gstnRecords?.map((singleDetailItem, keyIndex) => (
                                                            <tr key={keyIndex}>
                                                                <td>{keyIndex+1}</td>
                                                                <td>{singleDetailItem.registrationName || '-'}</td>
                                                                <td>{singleDetailItem.gstin || '-'}</td>
                                                                <td>{singleDetailItem.applicationStatus || '-'}</td>
                                                                <td>{singleDetailItem.mobNum || '-'}</td>
                                                                <td>{singleDetailItem.regType || '-'}</td>
                                                                <td>{singleDetailItem.emailId || '-'}</td>
                                                                <td>{singleDetailItem.tinNumber || '-'}</td>
                                                                <td>{singleDetailItem.gstinRefId || '-'}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </>}
                                            {singleDetail?.filingStatus.length!==0 && <>
                                                <h6>Filing status</h6>
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Filing year</th>
                                                            <th>Month of filing</th>
                                                            <th>Method of filling</th>
                                                            <th>Date of filing</th>
                                                            <th>GST type</th>
                                                            <th>GST status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {singleDetail?.filingStatus?.map((singleDetailItem, keyIndex) => (
                                                            <tr key={keyIndex}>
                                                                <td>{keyIndex+1}</td>
                                                                <td>{singleDetailItem.filingYear}</td>
                                                                <td>{singleDetailItem.monthOfFiling}</td>
                                                                <td>{singleDetailItem.methodOfFilling}</td>
                                                                <td>{singleDetailItem.dateOfFiling}</td>
                                                                <td>{singleDetailItem.gstType}</td>
                                                                <td>{singleDetailItem.gstStatus}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </>}
                                            <h6>Turnover</h6>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Message</th>
                                                        <th>GST estimated total</th>
                                                        <th>GST filed total</th>
                                                        <th>PAN estimated total</th>
                                                        <th>PAN filed total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {turnoverKeys.map((key, keyIndex) => (
                                                        <tr key={keyIndex}>
                                                            <td>{keyIndex+1}</td>
                                                            <td>{item?.turnoverData[key]?.message}</td>
                                                            <td>{item?.turnoverData[key]?.result?.gst_estimated_total || '-'}</td>
                                                            <td>{item?.turnoverData[key]?.result?.gst_filed_total || '-'}</td>
                                                            <td>{item?.turnoverData[key]?.result?.pan_estimated_total || '-'}</td>
                                                            <td>{item?.turnoverData[key]?.result?.pan_filed_total || '-'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                })}
                            </>
                        }
                    </Fragment>
                )
            })}
        </div>
    </>);
}

export default PANDetails;